import createUseStyles from '@picsart/rc/create';
import { FontSizes, FontWeights } from '@picsart/rc/fonts';

const useMenuStyles = createUseStyles(
  {
    root: {},
    navListItem: {
      fontSize: FontSizes.Size_4,
      color: 'var(--texts-negative)',
      display: 'inline-block',
    },
    navLink: {
      color: 'var(--texts-negative)',
      fontSize: FontSizes.Size_5,
      lineHeight: '35px',
      fontWeight: FontWeights.Medium,
      padding: '0 12px',
      display: 'block',
      transition: 'color 0.3s',

      '&:hover': {
        color: 'var(--accents-primary-base-action)',
      },

      '@media screen and (max-width: 1200px)': {
        fontSize: FontSizes.Size_4,
      },
    },
  },
  { name: 'menu' },
);

export default useMenuStyles;
